import Wizard from 'Layout/Wizard/Wizard';
import React, { lazy, Suspense } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

// non-lazy pages
import Faq from 'pages/Faq/Faq';
import OTP from 'pages/Migration/OTP';
import StudentDetailsLink from 'pages/Migration/StudentDetailsLink';
import Voucher from 'pages/Migration/Voucher';
import DeepLinkNewApp from 'pages/DeepLinks/DeepLinkNewApp';

const LandingPage = lazy(() => import('pages/LandingPage/LandingPage'));
const SchoolDetails = lazy(() => import('pages/SchoolDetails/SchoolDetails'));
const SchoolDetailsWaitingList = lazy(
  () =>
    import(
      'pages/SchoolDetails/SchoolDetailsWaitingList/SchoolDetailsWaitingList'
    )
);
const RegisterForWaitingListConfirmation = lazy(
  () =>
    import(
      'pages/RegisterForWaitingListConfirmation/RegisterForWaitingListConfirmation'
    )
);
const LockerMethod = lazy(() => import('pages/LockerMethod/LockerMethod'));
const ChooseGrade = lazy(() => import('pages/ChooseGrade/ChooseGrade'));
const ChooseCompound = lazy(
  () => import('pages/ChooseCompound/ChooseCompound')
);
const StudentDetails = lazy(
  () => import('pages/StudentDetails/StudentDetails')
);
const ChooseSubscription = lazy(
  () => import('pages/ChooseSubscription/ChooseSubscription')
);
const TransactionIframe = lazy(
  () => import('pages/TransactionIframe/TransactionIframe')
);
const TransactionIframeCallback = lazy(
  () =>
    import(
      'pages/TransactionIframe/TransactionIframeCallback/TransactionIframeCallback'
    )
);
const OrderSummary = lazy(() => import('pages/OrderSummary/OrderSummary'));
const OrderConfirmation = lazy(
  () => import('pages/OrderConfirmation/OrderConfirmation')
);
const Payment = lazy(() => import('pages/Payment/Payment'));
const Homepage = lazy(() => import('pages/Homepage/Homepage'));
const HowItWorks = lazy(() => import('pages/HowItWorks/HowItWorks'));

const MobileSuccess = lazy(
  () => import('pages/MOBILE_TRANZILA_URLS/MobileSuccess')
);
const MobileFailure = lazy(
  () => import('pages/MOBILE_TRANZILA_URLS/MobileFailure')
);

const PackageDeliveryConfirmation = lazy(
  () => import('pages/PackageDeliveryConfirmation/PackageDeliveryConfirmation')
);

export const ROUTES = {
  HOME: '/',
  VOUCHER_NUMBER: '/voucher-number',
  OTP: '/otp',
  STUDENT_DETAILS: '/student-details',
  HOW_IT_WORKS: '/how-it-works',
  FAQ: '/faq',
  APPROVE_ACTION_PERMISSION:
    '/ApproveActionPermission/:actionPermissionId/:approvalToken',

  MOBILE_SUCCESS: '/mobile/mobileSuccessPage',
  MOBILE_FAILURE: '/mobile/mobileFailurePage',
  DOWNLOAD_APP_NEW: '/download-app-new',

  ONBOARDING_LANDING_PAGE: '/onboarding/landing-page',
  ONBOARDING_SCHOOL_DETAILS: '/onboarding/school-details',
  ONBOARDING_REGISTER_FOR_WAITING_LIST: '/onboarding/register-for-waiting-list',
  ONBOARDING_REGISTER_FOR_WAITING_LIST_CONFIRMATION:
    '/onboarding/register-for-waiting-list-confirmation',
  ONBOARDING_LOCKER_METHOD: '/onboarding/locker-method',
  ONBOARDING_CHOOSE_GRADE: '/onboarding/choose-grade',
  ONBOARDING_CHOOSE_COMPOUND: '/onboarding/choose-compound',
  ONBOARDING_STUDENT_DETAILS: '/onboarding/student-details',
  ONBOARDING_CHOOSE_SUBSCRIPTION: '/onboarding/choose-subscription',
  ONBOARDING_TRANSACTION_IFRAME: '/onboarding/transaction-iframe',
  ONBOARDING_ORDER_SUMMARY: '/onboarding/order-summary',
  ONBOARDING_PAYMENT: '/onboarding/payment',
  ONBOARDING_TRANSACTION_IFRAME_CALLBACK:
    '/onboarding/transaction-iframe-callback',
  ONBOARDING_ORDER_CONFIRMATION: '/onboarding/order-confirmation',
};

const OnBoardingRoute = ({ path, children }) => (
  <Route path={path}>
    <Wizard>{children}</Wizard>
  </Route>
);

const Router = () => {
  const router = (
    <Suspense>
      <Switch>
        <Route path={ROUTES.VOUCHER_NUMBER}>
          <Voucher />
        </Route>
        <Route path={ROUTES.OTP}>
          <OTP />
        </Route>
        <Route path={ROUTES.STUDENT_DETAILS}>
          <StudentDetailsLink />
        </Route>
        <Route path={ROUTES.HOW_IT_WORKS}>
          <HowItWorks />
        </Route>
        <Route exact path={ROUTES.FAQ}>
          <Faq />
        </Route>
        <Route path={ROUTES.APPROVE_ACTION_PERMISSION}>
          <PackageDeliveryConfirmation />
        </Route>
        <Route path={ROUTES.HOME} exact>
          <Homepage />
        </Route>

        {/* !!!!!ONLY FOR MOBILE USES!!!!! */}
        <Route path={ROUTES.MOBILE_SUCCESS}>
          <MobileSuccess />
        </Route>
        <Route path={ROUTES.MOBILE_FAILURE}>
          <MobileFailure />
        </Route>
        <Route path={ROUTES.DOWNLOAD_APP_NEW}>
          <DeepLinkNewApp />
        </Route>

        {/* !!!!!ONLY FOR ONBOARDIND PROCCESS USES!!!!! */}
        <OnBoardingRoute path={ROUTES.ONBOARDING_LANDING_PAGE}>
          <LandingPage />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_SCHOOL_DETAILS}>
          <SchoolDetails />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_REGISTER_FOR_WAITING_LIST}>
          <SchoolDetailsWaitingList />
        </OnBoardingRoute>
        <OnBoardingRoute
          path={ROUTES.ONBOARDING_REGISTER_FOR_WAITING_LIST_CONFIRMATION}
        >
          <RegisterForWaitingListConfirmation />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_LOCKER_METHOD}>
          <LockerMethod />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_CHOOSE_GRADE}>
          <ChooseGrade />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_CHOOSE_COMPOUND}>
          <ChooseCompound />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_STUDENT_DETAILS}>
          <StudentDetails />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_CHOOSE_SUBSCRIPTION}>
          <ChooseSubscription />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_TRANSACTION_IFRAME}>
          <TransactionIframe />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_ORDER_SUMMARY}>
          <OrderSummary />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_PAYMENT}>
          <Payment />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_TRANSACTION_IFRAME_CALLBACK}>
          <TransactionIframeCallback />
        </OnBoardingRoute>
        <OnBoardingRoute path={ROUTES.ONBOARDING_ORDER_CONFIRMATION}>
          <OrderConfirmation />
        </OnBoardingRoute>

        {/* Default Redirect */}
        <Redirect to={'/'} />
      </Switch>
    </Suspense>
  );

  return router;
};

export default Router;
